// export function camel (str) {
//     const camel = (str || '').replace(/-([^-])/g, g => g[1].toUpperCase());
//
//     return capitalize(camel);
// }

// export function camelActual (str) {
//     return (str || '').replace(/-(\w)/g, (_, c) => (c ? c.toUpperCase() : ''));
// }

// export function kebab (str) {
//     return (str || '').replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();
// }

// export function capitalize (str) {
//     str = str || '';

//     return `${str.substr(0, 1).toUpperCase()}${str.slice(1)}`;
// }

// export function findProduct (store, id) {
//     return store.state.store.products.find(p => p.id === id);
// }

// export function isOnSale (variants) {
//     return variants.some(variant => {
//         return parseFloat(variant.price) < parseFloat(variant.compareAtPrice);
//     });
// }

// export function randomNumber (min, max) {
//     return Math.floor(Math.random() * max) + min;
// }

// export function randomString (length = 5) {
//     let text = '';
//     const possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
//
//     for (let i = 0; i < length; i++) {
//         text += possible.charAt(Math.floor(Math.random() * possible.length));
//     }
//
//     return text;
// }

const randomElement = (arr = []) => {
    return arr[Math.floor(Math.random() * arr.length)];
};

const kebab = (str) => {
    return (str || '').replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();
};

const toggleFullScreen = () => {
    let doc = window.document;
    let docEl = doc.documentElement;

    let requestFullScreen = docEl.requestFullscreen || docEl.mozRequestFullScreen || docEl.webkitRequestFullScreen || docEl.msRequestFullscreen;
    let cancelFullScreen = doc.exitFullscreen || doc.mozCancelFullScreen || doc.webkitExitFullscreen || doc.msExitFullscreen;

    if (!doc.fullscreenElement && !doc.mozFullScreenElement && !doc.webkitFullscreenElement && !doc.msFullscreenElement) {
        requestFullScreen.call(docEl);
    } else {
        cancelFullScreen.call(doc);
    }
};

const getErrorMsg = (responseData) => {
    const genericMsg = 'Oops... Erro inesperado!';
    let   result     = [];

    if (responseData.message) {
        result[result.length] = responseData.message;
    }

    if (responseData.errors && typeof responseData.errors == 'object' && responseData.errors.length > 0) {
        result[result.length] = " - " + responseData.errors.map(function(elem){ return elem.message; }).join("\n - ");
    }

    return {
        msg         : responseData.message ? responseData.message : genericMsg,
        detailedMsg : (result.length > 0) ? result.join("\n\n") : genericMsg
    }
}

const parseJwt = (token) => {
    var base64Url = token.split('.')[1];
    var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    var jsonPayload = decodeURIComponent(atob(base64).split('').map(function(c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));
    return JSON.parse(jsonPayload);
}

/**
 * @description determine if an array contains one or more items from another array.
 *
 * @param {array} haystack the array to search.
 * @param {array} arr the array providing items to check for in the haystack.
 *
 * @return {boolean} true|false if haystack contains at least one item from arr.
 */
const hasIn = (arrHaystack, arrNeedles) => arrNeedles.some(r => arrHaystack.indexOf(r) >= 0);

export default {
    randomElement,
    toggleFullScreen,
    kebab,
    getErrorMsg,
    parseJwt,
    hasIn
};
